import { Timestamp } from '@dixa/lib-shared-habla';
import { ampli } from 'lib-shared-tracking';

import { getUserDisplayName } from 'utils/user';

import { SubTitleRendererParams } from '../../subTitleRenderers';

export function sideConversationSubTitleRenderer(
  params: SubTitleRendererParams,
) {
  const { metaConversation } = params;
  const { conversation } = metaConversation;
  const { last_message_created_at: lastMessageCreatedAt } = conversation;

  const separator = ' · ';
  const CSID = metaConversation.conversation.id;
  const agentName = conversation.assignment?.agent
    ? getUserDisplayName(conversation.assignment.agent)
    : null;

  return (
    <>
      {CSID && <span>{`#${CSID}`}</span>}

      {lastMessageCreatedAt && (
        <>
          {separator}
          <span
            onClick={() =>
              ampli.conversationsTimestampClicked({
                context: 'created',
              })
            }
          >
            <Timestamp relative time={lastMessageCreatedAt} />
          </span>
        </>
      )}

      {agentName && (
        <>
          {separator}
          <span>{agentName}</span>
        </>
      )}
    </>
  );
}
